import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import $ from 'jquery';
import axios from "axios";

const Navbar = () => {
    const navigate = useNavigate();
    const logout = () => {
        axios.post('/logout').then((ok) => {
            if (ok.data !== 'err') {
                navigate('/')
            }
        })
    }

    useEffect(() => {
        $('[data-toggle="horizontal-menu-toggle"]').on("click", function () {
            $(".horizontal-menu .bottom-navbar").toggleClass("header-toggled");
        });

        if ($('.sidebar .sidebar-body').length) {
            const sidebarBodyScroll = new window.PerfectScrollbar('.sidebar-body');
        }

        $(document).on('click touchstart', function (e) {
            e.stopPropagation();
            if (!$(e.target).closest('.sidebar-toggler').length) {
                var sidebar = $(e.target).closest('.sidebar').length;
                var sidebarBody = $(e.target).closest('.sidebar-body').length;
                if (!sidebar && !sidebarBody) {
                    if ($('body').hasClass('sidebar-open')) {
                        $('body').removeClass('sidebar-open');
                    }
                }
            }
        });

        $(window).scroll(function () {
            if (window.matchMedia('(min-width: 992px)').matches) {
                var header = $('.horizontal-menu');
                if ($(window).scrollTop() >= 60) {
                    $(header).addClass('fixed-on-scroll');
                } else {
                    $(header).removeClass('fixed-on-scroll');
                }
            }
        });

        $('.sidebar .sidebar-body').hover(function () {
            $('body').addClass('overflow-hidden');
        }, function () {
            $('body').removeClass('overflow-hidden');
        });
    }, []);

    return (
        <nav className="navbar">
            <a href="/" className="sidebar-toggler" onClick={(e) => {
                e.preventDefault();
                $('.sidebar-header .sidebar-toggler').toggleClass('active not-active');
                if (window.matchMedia('(min-width: 992px)').matches) {
                    $('body').toggleClass('sidebar-folded');
                } else if (window.matchMedia('(max-width: 991px)').matches) {
                    $('body').toggleClass('sidebar-open');
                }
            }}>
                <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-menu"><line x1={3} y1={12} x2={21} y2={12} /><line x1={3} y1={6} x2={21} y2={6} /><line x1={3} y1={18} x2={21} y2={18} /></svg>
            </a>
            <div className="navbar-content">
                <ul className="navbar-nav link auth">
                    <li className="nav-item link">
                        <Link to="/product" className="btn btn-sm btn-inverse-primary">المواد</Link>
                    </li>
                    <li className="nav-item link">
                        <Link to="/user" className="btn btn-sm btn-inverse-primary">مستخدمين</Link>
                    </li>
                    <li className="nav-item link">
                        <Link to="/client" className="btn btn-sm btn-inverse-primary">حسابات</Link>
                    </li>
                </ul>
                <ul className="navbar-nav">
                    <li className="nav-item">
                        <a href="/" className="text-dark ms-0" onClick={() => { logout(); return false; }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-power"><path d="M18.36 6.64a9 9 0 1 1-12.73 0" /><line x1={12} y1={2} x2={12} y2={12} /></svg>
                        </a>
                    </li>
                </ul>
            </div>
        </nav>
    );
}

export default Navbar;